/**
 * DO NOT MODIFY THIS FILE!
 * It was created by the Reefer icons generator.
 * For updates, please re-run the generator.
 */

import type { SVGProps } from 'react';

import type { IconComponentProps } from '../../icon/icon.types';
import { Icon } from '../icon';

const Topical = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    fill="none"
    className="Icon/Topical"
    viewBox="0 0 24 24"
    {...props}
  >
    <g className="SVG">
      <g className="Main">
        <path
          fill="#CE349A"
          d="M5.5 7c0-.92.728-1.667 1.625-1.667h9.75c.897 0 1.625.747 1.625 1.667v13.333c0 .92-.728 1.667-1.625 1.667h-9.75c-.897 0-1.625-.746-1.625-1.667z"
        />
        <path
          fill="#CE349A"
          d="M8.547 2.833c0-.46.364-.833.812-.833h4.875c.449 0 .813.373.813.833v3.334c0 .46-.364.833-.813.833H9.36a.823.823 0 0 1-.812-.833z"
        />
      </g>
      <path
        fill="#000"
        fillOpacity={0.5}
        d="M8.75 10.333c0-.92.728-1.667 1.625-1.667H18.5v10h-8.125c-.897 0-1.625-.746-1.625-1.666z"
        className="Details"
      />
    </g>
  </svg>
);

export const TopicalIcon = ({
  size = 'md',
  'data-testid': testId,
  ...props
}: IconComponentProps) => {
  return (
    <Icon
      data-testid={testId || 'topical-icon'}
      icon={Topical}
      {...props}
      size={size}
    />
  );
};
